var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    clipPath: "url(#clip0_3847_30678)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.0834 8.34166L25.3751 2.71249L23.4938 4.94374L30.2022 10.5729L32.0834 8.34166ZM11.4917 4.94374L9.62508 2.71249L2.91675 8.32708L4.798 10.5583L11.4917 4.94374ZM18.2292 11.6667H16.0417V20.4167L22.9688 24.5729L24.0626 22.7792L18.2292 19.3229V11.6667ZM17.5001 5.83333C10.2522 5.83333 4.37508 11.7104 4.37508 18.9583C4.37508 26.2062 10.2376 32.0833 17.5001 32.0833C24.748 32.0833 30.6251 26.2062 30.6251 18.9583C30.6251 11.7104 24.748 5.83333 17.5001 5.83333ZM17.5001 29.1667C11.8563 29.1667 7.29175 24.6021 7.29175 18.9583C7.29175 13.3146 11.8563 8.74999 17.5001 8.74999C23.1438 8.74999 27.7084 13.3146 27.7084 18.9583C27.7084 24.6021 23.1438 29.1667 17.5001 29.1667Z",
    fill: "#6FCF97"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3847_30678"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.2a8ec8c1a304fbad1f8cdd80a5201591.svg";
export { ForwardRef as ReactComponent };